// Utility function same as Object.values()
// Input {"a": "value", "b": "value2"}
// Output: ["value", "value2"]
export function objectValues(obj) {
  if (!obj || typeof obj !== 'object') {
    return [];
  }
  try {
    return Object.keys(obj).map(function (e) {
      return obj[e];
    });
  } catch (error) {
    return [];
  }
}
